/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .happ-div-table[_ngcontent-%COMP%]{margin:auto 10px auto auto;border-right:1px solid gray;color:gray}"];
export { styles as styles };
